import React, { Children } from 'react';
import { Swiper as Swiper$1, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import styled from '../../../libs/styled.es.js';
import { iconMap } from '../../atoms/SvgIcon/icons.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div(({ theme }) => `.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}
&:hover {
  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background-color: rgba(168, 168, 168, 0.46);
  opacity: 0;
  &.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: auto;
  }
}
.swiper-pagination {
position: absolute;
text-align: center;
transform: translate3d(0, 0, 0);
z-index: 10;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ddd;
}
.swiper-container-horizontal {
z-index: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  cursor: pointer;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet-active {
  background: ${theme.brand.secondary};
  width: 24px;
  border-radius: 8px;
}
.swiper-button-next {
  right: 0;
  left: auto;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  &:after {
    mask: url("${iconMap["chevron-forward"]}");
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
}
.swiper-button-prev {
left: 0;
right: auto;
border-top-right-radius: 100px;
border-bottom-right-radius: 100px;
&:after {
  mask: url("${iconMap["chevron-back"]}");
  content: ' ';
  height: 30px;
  width: 30px;
  mask-size: contain;
  display: inline-block;
  background: #333;
}
}`);
const Swiper = (_a) => {
  var _b = _a, {
    children,
    hasNavigation,
    hasPagination,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "hasNavigation",
    "hasPagination",
    "className"
  ]);
  const swiperProps = Object.assign({}, props);
  if (hasNavigation && !props.navigation) {
    swiperProps.navigation = true;
    SwiperCore.use([Navigation]);
  }
  if (hasPagination && !props.pagination) {
    swiperProps.pagination = true;
    SwiperCore.use([Pagination]);
  }
  const { slidesPerView = "auto" } = swiperProps;
  const renderContent = (e, index, slidesPerView2) => {
    return /* @__PURE__ */ React.createElement(SwiperSlide, {
      style: {
        maxWidth: (slidesPerView2 === "auto" ? 100 : 100 / slidesPerView2) + "%"
      },
      key: index
    }, e);
  };
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(Swiper$1, __spreadValues({}, swiperProps), Children.map(children, (e, index) => renderContent(e, index, slidesPerView))));
};

export { Swiper };
